module.exports = __webpack_public_path__ + "static/media/generator-placeholder-img.a19a99db.svg";